var _circle, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EDF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25566:39203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 11.039C23.405 11.3 22.771 11.473 22.11 11.557C22.79 11.151 23.309 10.513 23.553 9.744C22.919 10.122 22.219 10.389 21.473 10.538C20.871 9.897 20.013 9.5 19.077 9.5C17.261 9.5 15.799 10.974 15.799 12.781C15.799 13.041 15.821 13.291 15.875 13.529C13.148 13.396 10.735 12.089 9.114 10.098C8.831 10.589 8.665 11.151 8.665 11.756C8.665 12.892 9.25 13.899 10.122 14.482C9.595 14.472 9.078 14.319 8.64 14.078C8.64 14.088 8.64 14.101 8.64 14.114C8.64 15.708 9.777 17.032 11.268 17.337C11.001 17.41 10.71 17.445 10.408 17.445C10.198 17.445 9.986 17.433 9.787 17.389C10.212 18.688 11.418 19.643 12.852 19.674C11.736 20.547 10.319 21.073 8.785 21.073C8.516 21.073 8.258 21.061 8 21.028C9.453 21.965 11.175 22.5 13.032 22.5C19.068 22.5 22.368 17.5 22.368 13.166C22.368 13.021 22.363 12.881 22.356 12.742C23.007 12.28 23.554 11.703 24 11.039Z",
    fill: "#03A9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25566:39203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.ed40faf2.svg";
export { ForwardRef as ReactComponent };